import {
  Button,
  Column,
  Columns,
  IconButton,
  Tooltip,
} from '@dixa/lib-shared-habla';
import { sizes } from '@dixa/lib-shared-tokens';
import * as Popover from '@radix-ui/react-popover';
import type { Table as TanstackTable } from '@tanstack/react-table';
import type { SearchConversationEnriched } from 'lib-search-types';

import type { ConversationsTableFeatures } from '../../conversationsTable.columns';

import { ConversationsTablePreferencesColumns } from './components/columns/conversationsTablePreferencesColumns';
import { ConversationsTablePreferencesDensity } from './components/density/conversationsTablePreferencesDensity';
import styles from './conversationsTablePreferences.module.scss';

export type ConversationsTablePreferencesProps = {
  /** The table whose columns the user chooses from. */
  table: TanstackTable<ConversationsTableFeatures, SearchConversationEnriched>;
};

/** A component that lets the user choose the density and the columns of the conversations table. */
export const ConversationsTablePreferences = ({
  table,
}: ConversationsTablePreferencesProps): JSX.Element | null => {
  const layout = table.options.meta?.layout;

  if (!layout) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Popover.Root>
        <Tooltip content="Customize the table" side="left">
          <Popover.Trigger asChild>
            <IconButton
              icon="preferences"
              variant="tertiary"
              aria-label="Customize the table"
            />
          </Popover.Trigger>
        </Tooltip>

        <Popover.Portal>
          <Popover.Content
            className={styles.popover}
            side="bottom"
            align="end"
            sideOffset={parseInt(sizes.spacer.values[100])}
          >
            <Columns>
              <Column size="300px">
                <Column.Row
                  className={styles.content}
                  noHorizontalPadding
                  noVerticalPadding
                  noMinHeight
                >
                  <ConversationsTablePreferencesDensity layout={layout} />

                  <ConversationsTablePreferencesColumns
                    table={table}
                    layout={layout}
                  />
                </Column.Row>

                <Column.Row
                  borderTop
                  noMinHeight
                  noHorizontalPadding
                  noVerticalPadding
                  className={styles.footer}
                >
                  <Button variant="secondary" onClick={layout.restoreDefaults}>
                    Restore defaults
                  </Button>
                </Column.Row>
              </Column>
            </Columns>
          </Popover.Content>
        </Popover.Portal>
      </Popover.Root>
    </div>
  );
};
